import React, { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
// Redux
import { useSelector } from "react-redux";
// Components
import Routes from "../routes";
// Languages
import global_en from "./translations/en/global.json";
import global_es from "./translations/es/global.json";
import global_ca from "./translations/ca/global.json";
import global_ua from "./translations/ua/global.json";

const I18Next = () => {
  const storeLng = useSelector(({ language }) => language.lng);

  useEffect(() => {
    i18next.init({
      interpolation: { escapeValue: false },
      lng: storeLng,
      resources: {
        en: {
          global: global_en,
        },
        es: {
          global: global_es,
        },
        ca: {
          global: global_ca,
        },
        ua: {
          global: global_ua,
        },
      },
    });
  }, [storeLng]);

  return (
    <I18nextProvider i18n={i18next}>
      <Routes />
    </I18nextProvider>
  );
};

export default I18Next;
